import React from 'react';
import styles from './styles.css';

const English = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <b>
          <li>DEFINITIONS</li>
        </b>
        <ol type="1">
          <li>
            "<b>AKULAKU</b>" is an organizer of electronic system in the form of
            mobile application (platform).
          </li>
          <li>
            "<b>AKULAKU Application</b>" means a mobile search app and store
            merchandise sold by registered Sellers, which provides certain
            facility services for registered Sellers to offer an unsecured
            installment payment feature for the purchase of goods sold by the
            Seller through the AKULAKU Application and can also be used as a
            payment solution in real time in Seller stores.
          </li>
          <li>
            "<b>User</b>" or hereinafter referred to as "User" is a party that
            uses AKULAKU services, including but not limited to buyers, sellers,
            or other parties downloading the AKULAKU Application. User is a
            competent party capable of binding itself in a valid agreement under
            the laws of the Republic of Indonesia.
          </li>
          <li>
            "<b>Buyer</b>" means a registered User who requests a Product sold
            by a registered seller and/or do payments through the AKULAKU
            Application.
          </li>
          <li>
            "<b>Seller</b>" means a registered users who agree to the sale of a
            Product to User and are willing to accept payment through the
            AKULAKU Application.
          </li>
          <li>
            "<b>AKULAKU Virtual Account</b>" means a joint account agreed upon
            by AKULAKU and User for transactional transaction processing in
            AKULAKU Application, including use of Installment Program.
          </li>
          <li>
            "<b>Credit Limit</b>" is the maximum amount of credit that can be
            entered by the Customer into his AKULAKU application with AKULAKU
            approval, to be used as a payment solution to the transaction he did
            at the MERCHANT store.
          </li>
          <li>
            "<b>Barcode</b>" is the codes for numbers and letters which consist
            of a combination of bars (lines) with various distances. This is one
            way to enter data into a computer. When the number is scanned by the
            cashier, the code will automatically be connected to the item data.
          </li>
          <li>
            "<b>Barcode Scanner</b>" is the AKULAKU mobile application that use
            Camera Based Barcode Readers as a payment tool for MERCHANT products
            by cutting the customer&apos;s credit limit on the AKULAKU
            application. The barcode scanner results contain data from various
            products such as the name MERCHANT, product name, price and other
            supporting data.
          </li>
          <li>
            "<b>Terms and Conditions</b>" means an agreement between the User
            and AKULAKU which contains a set of rules governing User and AKULAKU
            rights, obligations, responsibilities and the use of systems and
            services in the AKULAKU Application.
          </li>
        </ol>

        <b>
          <li>TERM OF SALES</li>
        </b>
        <ol type="1">
          <li>
            Seller are required to first apply to AKULAKU and then obtain
            AKULAKU approval in the form of a written agreement of the Merchant
            Agreement before selling the Product and/or Services and accept
            payment transaction solutions in AKULAKU Application.
          </li>
          <li>
            Seller are prohibited from manipulating the price of the Product
            and/or Services for any purpose, and prohibited from manipulating
            Product and/or Services transaction data, including but not limited
            to manipulating transaction data to increase the number of Seller
            transactions through AKULAKU Applications.
          </li>
          <li>
            Seller must provide data, information and description of Product
            completely and clearly in accordance with the condition and quality
            of the Products it sells. Seller acknowledges and agrees that
            AKULAKU reserves the right to cancel payment of Product and/or
            Services transactions in the event of a discrepancy between the
            data, information and description Product and/or Services provided
            by the Seller and Product and/or Services received by the Buyer.
          </li>
          <li>
            Seller are prohibited to make the terms and conditions of purchase
            of Products and/or Services in violation of applicable laws and
            regulations in Indonesia, including but not limited to the terms and
            conditions of the standard clauses which (i) are not receiving
            complaints; (ii) not receiving returns; ii) not receiving a refund,
            (iv) the product has no warranty, (v) depreciation of the value of
            the price.
          </li>
          <li>
            The Merchant understands and agrees that the price of the Product
            and/or Services paid through AKULAKU Application is inclusive of
            taxes, and the Seller Income Tax shall be reported and maintained by
            the respective Seller in accordance with the tax provisions
            applicable in the laws and regulations of Indonesia.
          </li>
          <li>
            During the sale process, Seller understands and agrees that AKULAKU
            may at any time verify and/or notify Seller by phone to Seller
            number. This verification and/or notification is an initiative of
            AKULAKU and can not be considered an AKULAKU liability, so the
            non-acceptance of a Seller phone call may not be a reason for Seller
            to discharge its obligations under these terms and conditions.
          </li>
        </ol>

        <b>
          <li>TERM OF BUYER</li>
        </b>
        <ol type="1">
          <li>
            Buyers can use payment solutions through the AKULAKU application,
            which is using the Barcode Scanner contained in the Buyer&apos;s
            camera phone to scan the Barcode printed on the Seller Dashboard.
            The seller will deduct the Buyer&apos;s funds in the Limit Credit at
            the AKULAKU Buyer Application
          </li>
          <li>
            When purchasing a Product, the Buyer agrees that the Buyer is
            responsible for reading, understanding, and approving the overall
            information and description of the Product (including but not
            limited to price, color, quality, function, type, specifications and
            other information) before making offer or commitment to buy Products
          </li>
          <li>
            Buyer enters into a legally binding agreement to purchase the
            Product when the Buyer buys a Product and pay it with AKULAKU
            application.
          </li>
          <li>
            Buyer understands and agrees that all transactions made between the
            Buyer and the Seller other than through the AKULAKU Virtual Account
            and/or without AKULAKU's knowledge (through personal messages,
            telephone correspondence with personal numbers, or other efforts)
            are the Buyer&apos;s personal responsibility.
          </li>
          <li>
            Buyer agrees not to disclose or submit proof of payment of the
            Product to another party other than AKULAKU. In the event of a loss
            due to notification or delivery of proof of payment by the Buyer to
            another party, it will be the responsibility of the Buyer
          </li>
          <li>
            Buyer understands and agrees that any claim submitted after
            confirmation or automatic confirmation of receipt of the Product is
            not the responsibility of AKULAKU, but is the responsibility of the
            Buyer personally.
          </li>
          <li>
            Buyer understands and agrees that the problem of late payment
            processing and additional fees caused by the difference between the
            Buyer bank and the AKULAKU Virtual Account bank are the
            responsibility of the Buyer personally
          </li>
        </ol>

        <b>
          <li>TERM OF PAYMENT METHOD</li>
        </b>
        <ol type="1">
          <li>
            Product Prices contained in the AKULAKU Application are the prices
            set by the Seller.
          </li>
          <li>
            Buyer selects the product in real time and then takes it to the
            cashier to enter the product data, price, and other data, then be
            paid using the Credit Limit in the AKULAKU application with the
            Barcode Scanner that is on the Buyer's cell phone.
          </li>
          <li>
            AKULAKU application currently only serves product sale and purchase
            transactions and makes payments in Rupiah.
          </li>
        </ol>

        <b>
          <li>TERMS OF RETURN / REPAIRS / REPLACEMENT</li>
        </b>
        <ol type="1">
          <li>
            Refunds to the Buyer can only be made if there are differences in
            product, price and other data in the Seller's dashboard with
            products, prices and other data in real time.
          </li>
          <li>
            All refunds will be made through the payment mechanism, where the
            refund will be made by bank transfer to the Buyer's personal bank
            account provided that the bank account details provided to AKULAKU
            are complete and accurate. Failure or delay in receiving refunds due
            to errors in providing account data or bank differences. Buyers with
            AKULAKU bank accounts are the responsibility of the Buyer
            personally.
          </li>
          <li>
            Buyer understands and agrees that AKULAKU collaborates with a third
            party namely Xendit to make a refund, and AKULAKU can use the
            Purchaser's data with Xendit for the purpose of carrying out the
            refund. 2) All returns must be made in accordance with the
            instructions specified in the Product Refund / Repair Terms in the
            application.
          </li>
          <li>
            Refunds will be made within 7-10 working days after the refund
            request is received and given approval based on AKULAKU
            verification.
          </li>
          <li>
            Buyer understands and agrees that AKULAKU has the right and
            authority to make changes to the refund mechanism without the
            obligation of prior notice.
          </li>
          <li>
            MERCHANT shall fill out and submit Product Information which can not
            be carried out the process of change / improvement on the
            description and product details.
          </li>
        </ol>

        <b>
          <li>TERMINATION</li>
        </b>
        <ol type="1">
          <li>
            This agreement will expire immediately by one of the parties with
            prior written notice of at least 30 (thirty) days before the term of
            the Agreement expires.
          </li>
        </ol>

        <b>
          <li>RENEWAL</li>
        </b>
        <ol type="1">
          <li>
            These Terms and Conditions submitted in writing may be subject to
            change at any time with notice. By continuing to access and use the
            AKULAKU service, MERCHANT considered to agree terms of condition
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default English;
